export const color_primary = '#35A8E0';
export const color_success = '#39C54A';
export const color_warning = '#9D7D1C';
